"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlGroupExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/control-group/examples/index.ts';
var options = ['Option 1', 'Option 2'];
var ControlGroupExample = /** @class */ (function () {
    function ControlGroupExample() {
    }
    ControlGroupExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { direction: 'column', src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.ControlGroup, { style: 'margin-bottom:15px' }, [
                (0, mithril_1.default)(_1.Input, {
                    contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.SEARCH }),
                    placeholder: 'Input placeholder...'
                }),
                (0, mithril_1.default)(_1.Button, {
                    iconLeft: _1.Icons.USERS,
                    label: 'Button'
                }),
                (0, mithril_1.default)(_1.Select, { options: options })
            ]),
            (0, mithril_1.default)(_1.ControlGroup, [
                (0, mithril_1.default)(_1.Button, {
                    iconLeft: _1.Icons.SETTINGS,
                    label: 'Action'
                }),
                (0, mithril_1.default)(_1.Input, {
                    contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.USER }),
                    contentRight: (0, mithril_1.default)(_1.Spinner, { active: true }),
                    placeholder: 'Enter name...'
                }),
                (0, mithril_1.default)(_1.CustomSelect, {
                    options: options,
                    defaultValue: 'Option 2'
                })
            ])
        ]);
    };
    return ControlGroupExample;
}());
exports.ControlGroupExample = ControlGroupExample;
